import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { ItemService } from '../../../service/item/item.service';
import { OwnerService } from '../../../service/owner/owner.service';
import { TypeColdService } from '../../../service/type-cold/type-cold.service';
import { UnitService } from '../../../service/unit/unit.service';
import { AbcService } from '../../../service/abc/abc.service';
import { CaseService } from '../../../service/case/case.service';
import { TypeunitpriceService } from '../../../service/typeunitprice/typeunitprice.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';
import { TypeItemService } from 'app/service/type-item/type-item.service';
import { throwMdDuplicatedSidenavError } from '@angular/material';

@Component({
  selector: 'wa9102',
  templateUrl: 'wa9102.component.html',
  styleUrls: ['wa9102.component.scss']
})
export class Wa9102Component implements OnInit, AfterViewInit {
  public componentTitle = 'WA9102:商品マスタ修正';

  public typecolds: any;
  public units: any;
  public owners: any;
  public abcs: any;
  public cases: any;
  public typeunitprices: any;
  public typeitems: object;

  public ownerId: FormControl;
  public itemId: number;
  public itemCd: string;
  public itemTx: FormControl;
  public lotFl: number;
  public typeitemCd: FormControl;
  public sameitemapplyFl = 0;
  public typecoldCd: FormControl;
  public uselimitFl: number;
  public fragilemarkFl = 0;
  public upwardmarkFl = 0;
  public itemlabeluseFl = 0;
  public arrivlabeluseFl: number;
  public shiplabeluseFl: number;
  public arriveuselimitNr: FormControl;
  public shipuselimitNr: FormControl;
  public unitId: FormControl;
  public unitTx: string;
  public itemabcId: FormControl;
  public caseCd: FormControl;
  public baraamountNr: FormControl;
  public pycaseCd: FormControl;            // ケース入り標準ケースコード(通常)
  public pycaseamountNr: FormControl;      // ケース入り標準ケース入数(通常)
  public bybaracaseCd: FormControl;        // バラ入り標準ケースコード(保管)
  public bybaracaseamountNr: FormControl;  // バラ入り標準ケース入数(保管)
  public bycaseCd: FormControl;            // ケース入り標準ケースコード(保管)
  public bycaseamountNr: FormControl;      // ケース入り標準ケース入数(保管)
  public maxpbinstockNr: FormControl;
  public inneramountNr: FormControl;
  public innerNr: FormControl;
  public caseamountNr: FormControl;
  public casespreadNr: FormControl;
  public casestackNr: FormControl;
  public pcsbarcodeTx: FormControl;
  public casebarcodeTx: FormControl;
  public lengthNr: FormControl;
  public widthNr: FormControl;
  public heightNr: FormControl;
  public volumeNr: FormControl;
  public weightNr: FormControl;
  public innerlengthNr: FormControl;
  public innerwidthNr: FormControl;
  public innerheightNr: FormControl;
  public caselengthNr: FormControl;
  public casewidthNr: FormControl;
  public caseheightNr: FormControl;
  public casevolumeNr: FormControl;
  public caseweightNr: FormControl;
  public typeunitpriceCd: FormControl;
  public stockunitpriceNr: FormControl;
  public arriveunitpriceNr: FormControl;
  public shipunitpriceNr: FormControl;
  public depositpriceNr: FormControl;
  public bsupppointbaraNr: FormControl;
  public bsupplimitbaraNr: FormControl;
  public supppointinnercaseNr: FormControl;   // 補充点(インナーケース・通常)
  public supplimitinnercaseNr: FormControl;  // 上限値(インナーケース・通常)
  public supppointcaseNr: FormControl;        // 補充点(ケース・通常)
  public supplimitcaseNr: FormControl;        // 上限値(ケース・通常)
  public itemPictures: string;
  public variation1Tx: FormControl;
  public variation2Tx: FormControl;
  public variation3Tx: FormControl;
  public displaypriceNr: FormControl;

  public updcounterNr: number;

  public validation = validation;

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public updVolumeFl = false;
  public updCaseVolumeFl = false;

  @Input() isShow = false;
  @Input() inputErrorMsg = '';
  @Output() closeButtonClick = new EventEmitter<boolean>();
  @Output() deleteButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private ownerTx: string;

  private errorInfo = '';
  private isArrivlabeluseFl = false; // MA_OWNERFUNCTIONにて、荷主の入荷ラベル運用フラグが1であればtrue
  private isShiplabeluseFl = false; // MA_OWNERFUNCTIONにて、荷主の出荷ラベル運用フラグが1であればtrue

  @ViewChild('scrollContent')
  scrollContent: ElementRef;

  private tabIndex = 0;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  public ownerIdCls = '';
  public itemCdCls = '';
  public itemTxCls = '';
  public lotFlCls = '';
  public typeitemCdCls = '';
  public sameitemapplyFlCls = '';
  public typecoldCdCls = '';
  public uselimitFlCls = '';
  public fragilemarkFlCls = '';
  public upwardmarkFlCls = '';
  public itemlabeluseFlCls = '';
  public arriveuselimitNrCls = '';
  public shipuselimitNrCls = '';
  public unitIdCls = '';
  public unitTxCls = '';
  public itemabcIdCls = '';
  public caseCdCls = '';
  public baraamountNrCls = '';
  public pycaseCdCls = '';
  public pycaseamountNrCls = '';
  public bybaracaseCdCls = '';
  public bybaracaseamountNrCls = '';
  public bycaseCdCls = '';
  public bycaseamountNrCls = '';
  public maxpbinstockNrCls = '';
  public inneramountNrCls = '';
  public innerNrCls = '';
  public caseamountNrCls = '';
  public casespreadNrCls = '';
  public casestackNrCls = '';
  public pcsbarcodeTxCls = '';
  public casebarcodeTxCls = '';
  public lengthNrCls = '';
  public widthNrCls = '';
  public heightNrCls = '';
  public volumeNrCls = '';
  public weightNrCls = '';
  public innerlengthNrCls = '';
  public innerwidthNrCls = '';
  public innerheightNrCls = '';
  public caselengthNrCls = '';
  public casewidthNrCls = '';
  public caseheightNrCls = '';
  public casevolumeNrCls = '';
  public caseweightNrCls = '';
  public typeunitpriceCdCls = '';
  public stockunitpriceNrCls = '';
  public arriveunitpriceNrCls = '';
  public shipunitpriceNrCls = '';
  public depositpriceNrCls = '';
  public bsupppointbaraNrCls = '';
  public bsupplimitbaraNrCls = '';
  public supppointinnercaseNrCls = '';
  public supplimitinnercaseNrCls = '';
  public supppointcaseNrCls = '';
  public supplimitcaseNrCls = '';
  public variation1TxCls = '';
  public variation2TxCls = '';
  public variation3TxCls = '';
  public displaypriceNrCls = '';
  public arrivlabeluseFlCls = '';
  public shiplabeluseFlCls = '';
  private isSubmitButtonEnabled = false;

  private item = null;
  private anchors = [0, 570, 2365, 2479, 2579];

  constructor(
    private router: Router,
    private itemService: ItemService,
    private ownerService: OwnerService,
    private typeColdService: TypeColdService,
    private unitService: UnitService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private abcService: AbcService,
    private caseService: CaseService,
    private typeunitpriceService: TypeunitpriceService,
    private typeitemService: TypeItemService,
  ) {
    (this.ownerId = new FormControl(0, [Validators.required])),
      (this.itemTx = new FormControl('', [
        Validators.required,
        Validators.pattern(validation.emBlankOnly),
        Validators.pattern(validation.halfBlankOnly),
        Validators.maxLength(validation.itemTx.maxLength)
      ])),
      (this.arriveuselimitNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.arriveuselimitNr.maxNr),
        Validators.min(validation.arriveuselimitNr.minNr)
      ])),
      (this.shipuselimitNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.shipuselimitNr.maxNr),
        Validators.min(validation.shipuselimitNr.minNr)
      ])),
      (this.typeitemCd = new FormControl('',)),
      (this.typecoldCd = new FormControl('', [Validators.required])),
      (this.unitId = new FormControl('', [Validators.required])),
      (this.itemabcId = new FormControl(0, [Validators.required])),
      (this.caseCd = new FormControl('', [Validators.required])),
      (this.baraamountNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.baraamountNr.maxNr),
        Validators.min(validation.baraamountNr.minNr)
      ])),
      this.pycaseCd = new FormControl('', [
        Validators.required,
      ]),
      this.pycaseamountNr = new FormControl(1, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.pycaseamountNr.maxNr),
        Validators.min(validation.pycaseamountNr.minNr),
      ]),
      this.bybaracaseCd = new FormControl('', [
        Validators.required,
      ]),
      this.bybaracaseamountNr = new FormControl(1, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.bybaracaseamountNr.maxNr),
        Validators.min(validation.bybaracaseamountNr.minNr),
      ]),
      this.bycaseCd = new FormControl('', [
        Validators.required,
      ]),
      this.bycaseamountNr = new FormControl(1, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.bycaseamountNr.maxNr),
      ]),
      (this.maxpbinstockNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.maxpbinstockNr.maxNr),
        Validators.min(validation.maxpbinstockNr.minNr)
      ])),
      (this.inneramountNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.inneramountNr.maxNr),
        Validators.min(validation.inneramountNr.minNr)
      ])),
      (this.innerNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.innerNr.maxNr),
        Validators.min(validation.innerNr.minNr)
      ])),
      (this.caseamountNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.caseamountNr.maxNr),
        Validators.min(validation.caseamountNr.minNr)
      ])),
      (this.casespreadNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.casespreadNr.maxNr),
        Validators.min(validation.casespreadNr.minNr)
      ])),
      (this.casestackNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.integer),
        Validators.max(validation.casestackNr.maxNr),
        Validators.min(validation.casestackNr.minNr)
      ])),
      (this.pcsbarcodeTx = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.halfBlankOnly),
        // Validators.pattern(validation.code39),
        Validators.maxLength(validation.pcsbarcodeTx.maxLength)
      ])),
      (this.casebarcodeTx = new FormControl('', [
        // Validators.required,
        Validators.pattern(validation.halfBlankOnly),
        // Validators.pattern(validation.code39),
        Validators.maxLength(validation.casebarcodeTx.maxLength)
      ])),
      (this.lengthNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_2),
        Validators.max(validation.lengthNr.maxNr),
        Validators.min(validation.lengthNr.minNr)
      ])),
      (this.widthNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_2),
        Validators.max(validation.widthNr.maxNr),
        Validators.min(validation.widthNr.minNr)
      ])),
      (this.heightNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_2),
        Validators.max(validation.heightNr.maxNr),
        Validators.min(validation.heightNr.minNr)
      ])),
      (this.volumeNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.volumeNr.maxNr),
        Validators.min(validation.volumeNr.minNr)
      ])),
      (this.weightNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.weightNr.maxNr),
        Validators.min(validation.weightNr.minNr)
      ])),
      (this.innerlengthNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.innerlengthNr.maxNr),
        Validators.min(validation.innerlengthNr.minNr)
      ])),
      (this.innerwidthNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.innerwidthNr.maxNr),
        Validators.min(validation.innerwidthNr.minNr)
      ])),
      (this.innerheightNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.innerheightNr.maxNr),
        Validators.min(validation.innerheightNr.minNr)
      ])),
      (this.caselengthNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.caselengthNr.maxNr),
        Validators.min(validation.caselengthNr.minNr)
      ])),
      (this.casewidthNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.casewidthNr.maxNr),
        Validators.min(validation.casewidthNr.minNr)
      ])),
      (this.caseheightNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.caseheightNr.maxNr),
        Validators.min(validation.caseheightNr.minNr)
      ])),
      (this.casevolumeNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.casevolumeNr.maxNr),
        Validators.min(validation.casevolumeNr.minNr)
      ])),
      (this.caseweightNr = new FormControl(0, [
        Validators.required,
        Validators.pattern(validation.decimal_3),
        Validators.max(validation.caseweightNr.maxNr),
        Validators.min(validation.caseweightNr.minNr)
      ]),
        (this.typeunitpriceCd = new FormControl('', [Validators.required])),
        (this.stockunitpriceNr = new FormControl(0, [
          Validators.required,
          Validators.pattern(validation.decimal_2),
          Validators.max(validation.stockunitpriceNr.maxNr),
          Validators.min(validation.stockunitpriceNr.minNr)
        ])),
        (this.arriveunitpriceNr = new FormControl(0, [
          Validators.required,
          Validators.pattern(validation.decimal_2),
          Validators.max(validation.arriveunitpriceNr.maxNr),
          Validators.min(validation.arriveunitpriceNr.minNr)
        ])),
        (this.shipunitpriceNr = new FormControl(0, [
          Validators.required,
          Validators.pattern(validation.decimal_2),
          Validators.max(validation.shipunitpriceNr.maxNr),
          Validators.min(validation.shipunitpriceNr.minNr)
        ])),
        (this.depositpriceNr = new FormControl(0, [
          Validators.required,
          Validators.pattern(validation.integer),
          Validators.max(validation.depositpriceNr.maxNr),
          Validators.min(validation.depositpriceNr.minNr)
        ])),
        (this.bsupppointbaraNr = new FormControl(0, [
          Validators.required,
          Validators.pattern(validation.integer),
          Validators.max(validation.bsupppointbaraNr.maxNr),
          Validators.min(validation.bsupppointbaraNr.minNr)
        ])),
        (this.bsupplimitbaraNr = new FormControl(0, [
          Validators.required,
          Validators.pattern(validation.integer),
          Validators.max(validation.bsupplimitbaraNr.maxNr),
          Validators.min(validation.bsupplimitbaraNr.minNr)
        ])),
        this.supppointinnercaseNr = new FormControl(0, [
          Validators.required,
          Validators.pattern(validation.integer),
          Validators.max(validation.supppointinnercaseNr.maxNr),
          Validators.min(validation.supppointinnercaseNr.minNr),
        ]),
        this.supplimitinnercaseNr = new FormControl(9999, [
          Validators.required,
          Validators.pattern(validation.integer),
          Validators.max(validation.supplimitinnercaseNr.maxNr),
          Validators.min(validation.supplimitinnercaseNr.minNr),
        ]),
        this.supppointcaseNr = new FormControl(0, [
          Validators.required,
          Validators.pattern(validation.integer),
          Validators.max(validation.supppointcaseNr.maxNr),
          Validators.min(validation.supppointcaseNr.minNr),
        ]),
        this.supplimitcaseNr = new FormControl(9999, [
          Validators.required,
          Validators.pattern(validation.integer),
          Validators.max(validation.supplimitcaseNr.maxNr),
          Validators.min(validation.supplimitcaseNr.minNr),
        ]),
        (this.variation1Tx = new FormControl('', [
          Validators.pattern(validation.emBlankOnly),
          Validators.pattern(validation.halfBlankOnly),
          Validators.maxLength(validation.variation1Tx.maxLength)
        ])),
        (this.variation2Tx = new FormControl('', [
          Validators.pattern(validation.emBlankOnly),
          Validators.pattern(validation.halfBlankOnly),
          Validators.maxLength(validation.variation2Tx.maxLength)
        ])),
        (this.variation3Tx = new FormControl('', [
          Validators.pattern(validation.emBlankOnly),
          Validators.pattern(validation.halfBlankOnly),
          Validators.maxLength(validation.variation3Tx.maxLength)
        ])),
        (this.displaypriceNr = new FormControl(0, [
          Validators.required,
          Validators.pattern(validation.integer),
          Validators.max(validation.displaypriceNr.maxNr),
          Validators.min(validation.displaypriceNr.minNr)
        ])),
        (this.containerHeight = window.innerHeight - config.containerheaderMargin));
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.working = true;
    // TODO should be execute parallel, but API server don't work properly
    this.ownerService
      .get()
      .then(outputJson => {
        console.log(JSON.stringify(outputJson));
        this.owners = outputJson.owners;
        this.typeColdService
          .get()
          .then(_outputJson => {
            console.log(JSON.stringify(_outputJson));
            this.typecolds = _outputJson.typecolds;
            this.unitService
              .get()
              .then(__outputJson => {
                this.working = false;
                console.log(JSON.stringify(__outputJson));
                this.units = __outputJson.units;
              })
              .catch(error => {
                this.working = false;
                this.errorInfo = this.commonService.getErrorMessage(error);
              });
          })
          .catch(error => {
            this.working = false;
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.abcService
      .get()
      .then(__outputJson => {
        this.abcs = __outputJson.abcs;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.caseService
      .get()
      .then(__outputJson => {
        this.cases = __outputJson.cases;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
    this.typeunitpriceService
      .get()
      .then(__outputJson => {
        this.typeunitprices = __outputJson.typeunitprices;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
      this.typeitemService
      .get()
      .then(___outputJson => {
        this.typeitems = ___outputJson.itemcategories;
      })
      .catch(error => {
        this.working = false;
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onSubmit() {
    this.errorInfo = '';
    var itemTx = this.itemTx.value.trim();
    var variation1Tx = this.variation1Tx.value.trim();
    var variation2Tx = this.variation2Tx.value.trim();
    var variation3Tx = this.variation3Tx.value.trim();
    var pcsbarcodeTx = this.pcsbarcodeTx.value.trim();
    var casebarcodeTx = this.casebarcodeTx.value.trim();
    let errors = false;

    if (this.ownerId.errors !== null) {
      this.ownerId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.itemTx.errors !== null) {
      this.itemTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.arriveuselimitNr.errors !== null) {
      this.arriveuselimitNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shipuselimitNr.errors !== null) {
      this.shipuselimitNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typeitemCd.errors !== null) {
      this.typeitemCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typecoldCd.errors !== null) {
      this.typecoldCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.unitId.errors !== null) {
      this.unitId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.itemabcId.errors !== null) {
      this.itemabcId.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caseCd.errors !== null) {
      this.caseCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.baraamountNr.errors !== null) {
      this.baraamountNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.pycaseCd.errors !== null) {
      this.pycaseCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.pycaseamountNr.errors !== null) {
      this.pycaseamountNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bybaracaseCd.errors !== null) {
      this.bybaracaseCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bybaracaseamountNr.errors !== null) {
      this.bybaracaseamountNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bycaseCd.errors !== null) {
      this.bycaseCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bycaseamountNr.errors !== null) {
      this.bycaseamountNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.maxpbinstockNr.errors !== null) {
      this.maxpbinstockNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.inneramountNr.errors !== null) {
      this.inneramountNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.innerNr.errors !== null) {
      this.innerNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caseamountNr.errors !== null) {
      this.caseamountNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.casespreadNr.errors !== null) {
      this.casespreadNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.casestackNr.errors !== null) {
      this.casestackNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.pcsbarcodeTx.errors !== null) {
      this.pcsbarcodeTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    /*
    if (this.casebarcodeTx.errors !== null) {
      this.casebarcodeTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    */
    if (this.lengthNr.errors !== null) {
      this.lengthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.widthNr.errors !== null) {
      this.widthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.heightNr.errors !== null) {
      this.heightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.volumeNr.errors !== null) {
      this.volumeNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.weightNr.errors !== null) {
      this.weightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.innerlengthNr.errors !== null) {
      this.innerlengthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.innerwidthNr.errors !== null) {
      this.innerwidthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.innerheightNr.errors !== null) {
      this.innerheightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caselengthNr.errors !== null) {
      this.caselengthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.casewidthNr.errors !== null) {
      this.casewidthNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caseheightNr.errors !== null) {
      this.caseheightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.casevolumeNr.errors !== null) {
      this.casevolumeNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.caseweightNr.errors !== null) {
      this.caseweightNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.typeunitpriceCd.errors !== null) {
      this.typeunitpriceCd.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.stockunitpriceNr.errors !== null) {
      this.stockunitpriceNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.arriveunitpriceNr.errors !== null) {
      this.arriveunitpriceNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.shipunitpriceNr.errors !== null) {
      this.shipunitpriceNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.depositpriceNr.errors !== null) {
      this.depositpriceNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bsupppointbaraNr.errors !== null) {
      this.bsupppointbaraNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.bsupplimitbaraNr.errors !== null) {
      this.bsupplimitbaraNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.supppointinnercaseNr.errors !== null) {
      this.supppointinnercaseNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.supplimitinnercaseNr.errors !== null) {
      this.supplimitinnercaseNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.supppointcaseNr.errors !== null) {
      this.supppointcaseNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.supplimitcaseNr.errors !== null) {
      this.supplimitcaseNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    /*
    if (this.variation1Tx.errors !== null) {
      this.variation1Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.variation2Tx.errors !== null) {
      this.variation2Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (this.variation3Tx.errors !== null) {
      this.variation3Tx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    */
    if (this.displaypriceNr.errors !== null) {
      this.displaypriceNr.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    if (this.innerNr.value == 0) {
      if (this.inneramountNr.value != 1) {
        //インナーケースが存在しない場合、インナーケース数=1、となること
        this.errorInfo = 'インナーケースが存在しない場合、インナーケース入数は1としてしてください。';
        return;
      }
    } else {
      if (this.caseamountNr.value != this.inneramountNr.value * this.innerNr.value) {
        //ケース数＝インナーケース入数×インナーケース数、となること
        this.errorInfo = 'インナーケースが存在する場合、ケース入数＝インナーケース入数×インナーケース数となるよう入力してください。';
        return;
      }
    }
    const upduserId: number = JSON.parse(sessionStorage.getItem('loginResult'))['user']['userId'];
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.itemService
      .put(
        this.ownerId.value,
        this.itemId,
        this.itemCd,
        itemTx,
        this.lotFl,
        this.uselimitFl,
        this.fragilemarkFl,
        this.upwardmarkFl,
        this.itemlabeluseFl,
        this.arrivlabeluseFl,
        this.shiplabeluseFl,
        this.typeitemCd.value,
        this.sameitemapplyFl,
        this.typecoldCd.value,
        this.arriveuselimitNr.value,
        this.shipuselimitNr.value,
        this.unitId.value,
        this.itemabcId.value,
        this.caseCd.value,
        this.baraamountNr.value,
        this.pycaseCd.value,
        this.pycaseamountNr.value,
        this.bybaracaseCd.value,
        this.bybaracaseamountNr.value,
        this.bycaseCd.value,
        this.bycaseamountNr.value,
        // this.maxpbinstockNr.value,
        this.inneramountNr.value,
        this.innerNr.value,
        this.caseamountNr.value,
        this.casespreadNr.value,
        this.casestackNr.value,
        pcsbarcodeTx,
        casebarcodeTx,
        this.lengthNr.value,
        this.widthNr.value,
        this.heightNr.value,
        this.volumeNr.value,
        this.weightNr.value,
        this.innerlengthNr.value,
        this.innerwidthNr.value,
        this.innerheightNr.value,
        this.caselengthNr.value,
        this.casewidthNr.value,
        this.caseheightNr.value,
        this.casevolumeNr.value,
        this.caseweightNr.value,
        this.typeunitpriceCd.value,
        this.stockunitpriceNr.value,
        this.arriveunitpriceNr.value,
        this.shipunitpriceNr.value,
        this.depositpriceNr.value,
        this.bsupppointbaraNr.value,
        this.bsupplimitbaraNr.value,
        this.supppointinnercaseNr.value,
        this.supplimitinnercaseNr.value,
        this.supppointcaseNr.value,
        this.supplimitcaseNr.value,
        variation1Tx,
        variation2Tx,
        variation3Tx,
        this.displaypriceNr.value,
        'wa9102',
        this.updcounterNr
      )
      .then(outputJson => {
        this.working = false;
        sessionStorage.removeItem('rowItems');
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  getVolumeNr() {
    let VolumeNr;
    VolumeNr = this.lengthNr.value * this.widthNr.value * this.heightNr.value * 0.000001;
    //小数点3まで四捨五入する
    VolumeNr = VolumeNr * 1000;
    VolumeNr = Math.round(VolumeNr) / 1000;
    return VolumeNr;
  }

  getCaseVolumeNr() {
    let caseVolumeNr;
    caseVolumeNr = this.caselengthNr.value * this.casewidthNr.value * this.caseheightNr.value * 0.000001;
    //小数点3まで四捨五入する
    caseVolumeNr = caseVolumeNr * 1000;
    caseVolumeNr = Math.round(caseVolumeNr) / 1000;
    return caseVolumeNr;
  }

  selectPicture() {
    this.router.navigate(['wa9104']);
  }

  cancel() {
    this.errorInfo = '';

    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.inputErrorMsg != null && this.inputErrorMsg.length > 0) {
      this.errorInfo = this.inputErrorMsg;
      return;
    }

    if (this.isShow) {
      this.inputErrorMsg = "";
      this.isDelayHide = false;
      this.errorInfo = '';
      this.initDatas();
    } else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    const items: object = JSON.parse(sessionStorage.getItem('rowItems'));
    this.item = items;

    let ownerFunctionsArray = JSON.parse(sessionStorage.getItem('ownerFunctions')).ownerFunctions;
    this.isArrivlabeluseFl = this.commonService.isArrivlabeluseFl(ownerFunctionsArray,items['ownerId']);
    this.isShiplabeluseFl = this.commonService.isShiplabeluseFl(ownerFunctionsArray,items['ownerId']);

    var ownerId = items['ownerId'];
    this.itemId = items['itemId'];
    this.itemCd = items['itemCd'];
    var itemTx = items['itemTx'];
    if(items['lotFlTx'] == 'する'){
      this.lotFl = 1;
    }else{
      this.lotFl = 0;
    }
    if(items['sameitemapplyFlTx'] == 'する'){
      this.sameitemapplyFl = 1;
    }else{
      this.sameitemapplyFl = 0;
    }
    if(items['fragilemarkFlTx'] == 'する'){
      this.fragilemarkFl = 1;
    }else{
      this.fragilemarkFl = 0;
    }
    if(items['upwardmarkFlTx'] == 'する'){
      this.upwardmarkFl = 1;
    }else{
      this.upwardmarkFl = 0;
    }
    if(items['itemlabeluseFlTx'] == 'する'){
      this.itemlabeluseFl = 1;
    }else{
      this.itemlabeluseFl = 0;
    }
    if(items['uselimitFlTx'] == 'する'){
      this.uselimitFl = 1;
    }else{
      this.uselimitFl = 0;
    }
    if(items['arrivlabeluseFlTx'] == 'する'){
      this.arrivlabeluseFl = 1;
    }else{
      this.arrivlabeluseFl = 0;
    }
    if(items['shiplabeluseFlTx'] == 'する'){
      this.shiplabeluseFl = 1;
    }else{
      this.shiplabeluseFl = 0;
    }
    let typeitemCd = items['typeitemCd'];
    var typecoldCd = items['typecoldCd'];
    var arriveuselimitNr = items['arriveuselimitNr'];
    var shipuselimitNr = items['shipuselimitNr'];
    var unitId = items['pcsunitId'];
    this.unitTx = items['pcsunitTx'];
    var itemabcId = items['itemabcId'];
    var caseCd = items['baracaseCd'];
    var baraamountNr = items['baraamountNr'];
    let pycaseCd = items['pycaseCd'];
    let pycaseamountNr = items['pycaseamountNr'];
    let bybaracaseCd = items['bybaracaseCd'];
    let bybaracaseamountNr = items['bybaracaseamountNr'];
    let bycaseCd = items['bycaseCd'];
    let bycaseamountNr = items['bycaseamountNr'];
    var maxpbinstockNr = items['maxpbinstockNr'];
    var inneramountNr = items['inneramountNr'];
    var innerNr = items['innerNr'];
    var caseamountNr = items['caseamountNr'];
    var casespreadNr = items['casespreadNr'];
    var casestackNr = items['casestackNr'];
    var pcsbarcodeTx = items['pcsbarcodeTx'];
    var casebarcodeTx = items['casebarcodeTx'];
    var lengthNr = items['lengthNr'];
    var widthNr = items['widthNr'];
    var heightNr = items['heightNr'];
    var volumeNr = items['volumeNr'];
    var weightNr = items['weightNr'];
    var innerlengthNr = items['innerlengthNr'];
    var innerwidthNr = items['innerwidthNr'];
    var innerheightNr = items['innerheightNr'];
    var caselengthNr = items['caselengthNr'];
    var casewidthNr = items['casewidthNr'];
    var caseheightNr = items['caseheightNr'];
    var casevolumeNr = items['casevolumeNr'];
    var caseweightNr = items['caseweightNr'];
    var typeunitpriceCd = items['typeunitpriceCd'];
    var stockunitpriceNr = items['stockunitpriceNr'];
    var arriveunitpriceNr = items['arriveunitpriceNr'];
    var shipunitpriceNr = items['shipunitpriceNr'];
    var depositpriceNr = items['depositpriceNr'];
    var bsupppointbaraNr = items['bsupppointbaraNr'];
    var bsupplimitbaraNr = items['bsupplimitbaraNr'];
    let supppointinnercaseNr = items['supppointinnercaseNr'];
    let supplimitinnercaseNr = items['supplimitinnercaseNr'];
    let supppointcaseNr = items['supppointcaseNr'];
    let supplimitcaseNr = items['supplimitcaseNr'];
    this.itemPictures = items['itempictures'];
    var variation1Tx = items['variation1Tx'];
    var variation2Tx = items['variation2Tx'];
    var variation3Tx = items['variation3Tx'];
    var displaypriceNr = items['displaypriceNr'];

    this.ownerTx = items['ownerTx'];

    this.updcounterNr = items['updcounterNr'];

    this.ownerId.setValue(ownerId);
    this.itemTx.setValue(itemTx);
    this.arriveuselimitNr.setValue(arriveuselimitNr);
    this.shipuselimitNr.setValue(shipuselimitNr);
    this.typeitemCd.setValue(typeitemCd);
    this.typecoldCd.setValue(typecoldCd);
    this.unitId.setValue(unitId);
    this.itemabcId.setValue(itemabcId);
    this.caseCd.setValue(caseCd);
    this.baraamountNr.setValue(baraamountNr);
    this.pycaseCd.setValue(pycaseCd);
    this.pycaseamountNr.setValue(pycaseamountNr);
    this.bybaracaseCd.setValue(bybaracaseCd);
    this.bybaracaseamountNr.setValue(bybaracaseamountNr);
    this.bycaseCd.setValue(bycaseCd);
    this.bycaseamountNr.setValue(bycaseamountNr);
    this.maxpbinstockNr.setValue(maxpbinstockNr);
    this.inneramountNr.setValue(inneramountNr);
    this.innerNr.setValue(innerNr);
    this.caseamountNr.setValue(caseamountNr);
    this.casespreadNr.setValue(casespreadNr);
    this.casestackNr.setValue(casestackNr);
    this.pcsbarcodeTx.setValue(pcsbarcodeTx);
    this.casebarcodeTx.setValue(casebarcodeTx);
    this.lengthNr.setValue(lengthNr);
    this.widthNr.setValue(widthNr);
    this.heightNr.setValue(heightNr);
    this.volumeNr.setValue(volumeNr);
    this.weightNr.setValue(weightNr);
    this.innerlengthNr.setValue(innerlengthNr);
    this.innerwidthNr.setValue(innerwidthNr);
    this.innerheightNr.setValue(innerheightNr);
    this.caselengthNr.setValue(caselengthNr);
    this.casewidthNr.setValue(casewidthNr);
    this.caseheightNr.setValue(caseheightNr);
    this.casevolumeNr.setValue(casevolumeNr);
    this.caseweightNr.setValue(caseweightNr);
    this.typeunitpriceCd.setValue(typeunitpriceCd);
    this.stockunitpriceNr.setValue(stockunitpriceNr);
    this.arriveunitpriceNr.setValue(arriveunitpriceNr);
    this.shipunitpriceNr.setValue(shipunitpriceNr);
    this.depositpriceNr.setValue(depositpriceNr);
    this.bsupppointbaraNr.setValue(bsupppointbaraNr);
    this.bsupplimitbaraNr.setValue(bsupplimitbaraNr);
    this.supppointinnercaseNr.setValue(supppointinnercaseNr);
    this.supplimitinnercaseNr.setValue(supplimitinnercaseNr);
    this.supppointcaseNr.setValue(supppointcaseNr);
    this.supplimitcaseNr.setValue(supplimitcaseNr);
    this.variation1Tx.setValue(variation1Tx);
    this.variation2Tx.setValue(variation2Tx);
    this.variation3Tx.setValue(variation3Tx);
    this.displaypriceNr.setValue(displaypriceNr);
    this.updVolumeFl = false;
    this.updCaseVolumeFl = false;
    setTimeout(() => {
      this.scrollContent.nativeElement.scrollTop = 0;
    }, 200);
  }

  changeTab(idx) {
    let position = this.anchors[0];
    switch (idx) {
      case 1:
        position = this.anchors[1];
        break;
      case 2:
        // 荷主の入荷ラベル運用フラグ/出荷ラベル運用フラグに応じてpositionを変更する
        if(this.isArrivlabeluseFl && this.isShiplabeluseFl){
          position = this.anchors[4];
        }else if(this.isArrivlabeluseFl || this.isShiplabeluseFl){
          position = this.anchors[3];
        }else{
          position = this.anchors[2];
        }
        break;
    }
    this.tabIndex = idx;
    this.scrollContent.nativeElement.scrollTop = position;
  }

  ngDoCheck() {
    if (!this.isShow || this.item == null) return;

    if(this.caseCd.value === '999') {
      this.baraamountNr.disable();
    } else this.baraamountNr.enable();

    if(this.pycaseCd.value === '999') {
      this.pycaseamountNr.disable();
    } else this.pycaseamountNr.enable();

    if(this.bybaracaseCd.value === '999') {
      this.bybaracaseamountNr.disable();
    } else this.bybaracaseamountNr.enable();

    if(this.bycaseCd.value === '999') {
      this.bycaseamountNr.disable();
    } else this.bycaseamountNr.enable();

    if(this.uselimitFl == 0) {
      this.arriveuselimitNr.disable();
      this.shipuselimitNr.disable();
    } else {
      this.arriveuselimitNr.enable();
      this.shipuselimitNr.enable();
    }

    this.itemTxCls = this.itemTx.value === this.item['itemTx'] ? '' : this.itemTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.lotFlCls = this.lotFl == this.item['lotFl'] ? '' : this.STRINGS_ACTIVE;
    this.fragilemarkFlCls = this.fragilemarkFl == this.item['fragilemarkFl'] ? '' : this.STRINGS_ACTIVE;
    this.upwardmarkFlCls = this.upwardmarkFl == this.item['upwardmarkFl'] ? '' : this.STRINGS_ACTIVE;
    this.itemlabeluseFlCls = this.itemlabeluseFl == this.item['itemlabeluseFl'] ? '' : this.STRINGS_ACTIVE;
    this.sameitemapplyFlCls = this.sameitemapplyFl == this.item['sameitemapplyFl'] ? '' : this.STRINGS_ACTIVE;
    this.typeitemCdCls = this.typeitemCd.value == this.item['typeitemCd'] ? '' : this.typeitemCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.typecoldCdCls = this.typecoldCd.value == this.item['typecoldCd'] ? '' : this.typecoldCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.uselimitFlCls = this.uselimitFl == this.item['uselimitFl'] ? '' : this.STRINGS_ACTIVE;
    this.arriveuselimitNrCls = this.arriveuselimitNr.value == this.item['arriveuselimitNr'] ? '' : this.arriveuselimitNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.shipuselimitNrCls = this.shipuselimitNr.value == this.item['shipuselimitNr'] ? '' : this.shipuselimitNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.unitIdCls = this.unitId.value === this.item['pcsunitId'] ? '' : this.unitId.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.unitTxCls = this.unitTx === this.item['pcsunitTx'] ? '' : this.STRINGS_ACTIVE;
    this.itemabcIdCls = this.itemabcId.value === this.item['itemabcId'] ? '' : this.itemabcId.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.caseCdCls = this.caseCd.value === this.item['baracaseCd'] ? '' : this.caseCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.baraamountNrCls = this.baraamountNr.value == this.item['baraamountNr'] ? '' : this.baraamountNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.pycaseCdCls = this.pycaseCd.value === this.item['pycaseCd'] ? '' : this.pycaseCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.pycaseamountNrCls = this.pycaseamountNr.value === this.item['pycaseamountNr'] ? '' : this.pycaseamountNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.bybaracaseCdCls = this.bybaracaseCd.value === this.item['bybaracaseCd'] ? '' : this.bybaracaseCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.bybaracaseamountNrCls = this.bybaracaseamountNr.value === this.item['bybaracaseamountNr'] ? '' : this.bybaracaseamountNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.bycaseCdCls = this.bycaseCd.value === this.item['bycaseCd'] ? '' : this.bycaseCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.bycaseamountNrCls = this.bycaseamountNr.value === this.item['bycaseamountNr'] ? '' : this.bycaseamountNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    // this.maxpbinstockNrCls = this.maxpbinstockNr.value == this.item['maxpbinstockNr'] ? '' : this.maxpbinstockNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.inneramountNrCls = this.inneramountNr.value == this.item['inneramountNr'] ? '' : this.inneramountNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.innerNrCls = this.innerNr.value == this.item['innerNr'] ? '' : this.innerNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.caseamountNrCls = this.caseamountNr.value == this.item['caseamountNr'] ? '' : this.caseamountNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.casespreadNrCls = this.casespreadNr.value == this.item['casespreadNr'] ? '' : this.casespreadNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.casestackNrCls = this.casestackNr.value == this.item['casestackNr'] ? '' : this.casestackNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.pcsbarcodeTxCls = this.pcsbarcodeTx.value === this.item['pcsbarcodeTx'] ? '' : this.pcsbarcodeTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.casebarcodeTxCls = this.casebarcodeTx.value === this.item['casebarcodeTx'] ? '' : this.casebarcodeTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.lengthNrCls = this.lengthNr.value == this.item['lengthNr'] ? '' : this.lengthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.widthNrCls = this.widthNr.value == this.item['widthNr'] ? '' : this.widthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.heightNrCls = this.heightNr.value == this.item['heightNr'] ? '' : this.heightNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.volumeNrCls = this.volumeNr.value == this.item['volumeNr'] ? '' : this.volumeNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.weightNrCls = this.weightNr.value == this.item['weightNr'] ? '' : this.weightNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.innerlengthNrCls = this.innerlengthNr.value == this.item['innerlengthNr'] ? '' : this.innerlengthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.innerwidthNrCls = this.innerwidthNr.value == this.item['innerwidthNr'] ? '' : this.innerwidthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.innerheightNrCls = this.innerheightNr.value == this.item['innerheightNr'] ? '' : this.innerheightNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.caselengthNrCls = this.caselengthNr.value == this.item['caselengthNr'] ? '' : this.caselengthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.casewidthNrCls = this.casewidthNr.value == this.item['casewidthNr'] ? '' : this.casewidthNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.caseheightNrCls = this.caseheightNr.value == this.item['caseheightNr'] ? '' : this.caseheightNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.casevolumeNrCls = this.casevolumeNr.value == this.item['casevolumeNr'] ? '' : this.casevolumeNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.caseweightNrCls = this.caseweightNr.value == this.item['caseweightNr'] ? '' : this.caseweightNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.typeunitpriceCdCls = this.typeunitpriceCd.value === this.item['typeunitpriceCd'] ? '' : this.typeunitpriceCd.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.stockunitpriceNrCls = this.stockunitpriceNr.value == this.item['stockunitpriceNr'] ? '' : this.stockunitpriceNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.arriveunitpriceNrCls = this.arriveunitpriceNr.value == this.item['arriveunitpriceNr'] ? '' : this.arriveunitpriceNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.shipunitpriceNrCls = this.shipunitpriceNr.value == this.item['shipunitpriceNr'] ? '' : this.shipunitpriceNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.depositpriceNrCls = this.depositpriceNr.value == this.item['depositpriceNr'] ? '' : this.depositpriceNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.bsupppointbaraNrCls = this.bsupppointbaraNr.value == this.item['bsupppointbaraNr'] ? '' : this.bsupppointbaraNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.bsupplimitbaraNrCls = this.bsupplimitbaraNr.value == this.item['bsupplimitbaraNr'] ? '' : this.bsupplimitbaraNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.supppointinnercaseNrCls = this.supppointinnercaseNr.value === this.item['supppointinnercaseNr'] ? '' : this.supppointinnercaseNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.supplimitinnercaseNrCls = this.supplimitinnercaseNr.value === this.item['supplimitinnercaseNr'] ? '' : this.supplimitinnercaseNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.supppointcaseNrCls = this.supppointcaseNr.value === this.item['supppointcaseNr'] ? '' : this.supppointcaseNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.supplimitcaseNrCls = this.supplimitcaseNr.value === this.item['supplimitcaseNr'] ? '' : this.supplimitcaseNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.variation1TxCls = this.variation1Tx.value === this.item['variation1Tx'] ? '' : this.variation1Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.variation2TxCls = this.variation2Tx.value === this.item['variation2Tx'] ? '' : this.variation2Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.variation3TxCls = this.variation3Tx.value === this.item['variation3Tx'] ? '' : this.variation3Tx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.displaypriceNrCls = this.displaypriceNr.value == this.item['displaypriceNr'] ? '' : this.displaypriceNr.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR;
    this.arrivlabeluseFlCls = this.arrivlabeluseFl == (this.item['arrivlabeluseFlTx'] === 'する' ? 1 : 0) ? '' : this.STRINGS_ACTIVE;
    this.shiplabeluseFlCls = this.shiplabeluseFl == (this.item['shiplabeluseFlTx'] === 'する' ? 1 : 0) ? '' : this.STRINGS_ACTIVE;


    if(this.lengthNrCls === this.STRINGS_ACTIVE || this.widthNrCls === this.STRINGS_ACTIVE || this.heightNrCls === this.STRINGS_ACTIVE || this.updVolumeFl === true){
      this.volumeNr.setValue(this.getVolumeNr());
      this.updVolumeFl = true;
    }else{
      this.volumeNr.setValue(this.item['volumeNr']);
    }
    if(this.caselengthNrCls === this.STRINGS_ACTIVE || this.casewidthNrCls === this.STRINGS_ACTIVE || this.caseheightNrCls === this.STRINGS_ACTIVE || this.updCaseVolumeFl === true){
      this.casevolumeNr.setValue(this.getCaseVolumeNr());
      this.updCaseVolumeFl = true;
    }else{
      this.casevolumeNr.value == this.item['casevolumeNr']
    }
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    if (
      this.itemTxCls !== this.STRINGS_ERROR &&
      this.lotFlCls !== this.STRINGS_ERROR &&
      this.fragilemarkFlCls !== this.STRINGS_ERROR &&
      this.upwardmarkFlCls !== this.STRINGS_ERROR &&
      this.itemlabeluseFlCls !== this.STRINGS_ERROR &&
      this.typecoldCdCls !== this.STRINGS_ERROR &&
      this.typeitemCdCls !== this.STRINGS_ERROR &&
      this.sameitemapplyFlCls !== this.STRINGS_ERROR &&
      this.uselimitFlCls !== this.STRINGS_ERROR &&
      this.arriveuselimitNrCls !== this.STRINGS_ERROR &&
      this.shipuselimitNrCls !== this.STRINGS_ERROR &&
      this.unitIdCls !== this.STRINGS_ERROR &&
      this.unitTxCls !== this.STRINGS_ERROR &&
      this.itemabcIdCls !== this.STRINGS_ERROR &&
      this.caseCdCls !== this.STRINGS_ERROR &&
      this.baraamountNrCls !== this.STRINGS_ERROR &&
      this.pycaseCdCls !== this.STRINGS_ERROR &&
      this.pycaseamountNrCls !== this.STRINGS_ERROR &&
      this.bybaracaseCdCls !== this.STRINGS_ERROR &&
      this.bybaracaseamountNrCls !== this.STRINGS_ERROR &&
      this.bycaseCdCls !== this.STRINGS_ERROR &&
      this.bycaseamountNrCls !== this.STRINGS_ERROR &&
      // this.maxpbinstockNrCls !== this.STRINGS_ERROR &&
      this.inneramountNrCls !== this.STRINGS_ERROR &&
      this.innerNrCls !== this.STRINGS_ERROR &&
      this.caseamountNrCls !== this.STRINGS_ERROR &&
      this.casespreadNrCls !== this.STRINGS_ERROR &&
      this.casestackNrCls !== this.STRINGS_ERROR &&
      this.pcsbarcodeTxCls !== this.STRINGS_ERROR &&
      this.casebarcodeTxCls !== this.STRINGS_ERROR &&
      this.lengthNrCls !== this.STRINGS_ERROR &&
      this.widthNrCls !== this.STRINGS_ERROR &&
      this.heightNrCls !== this.STRINGS_ERROR &&
      this.volumeNrCls !== this.STRINGS_ERROR &&
      this.weightNrCls !== this.STRINGS_ERROR &&
      this.innerlengthNrCls !== this.STRINGS_ERROR &&
      this.innerwidthNrCls !== this.STRINGS_ERROR &&
      this.innerheightNrCls !== this.STRINGS_ERROR &&
      this.caselengthNrCls !== this.STRINGS_ERROR &&
      this.casewidthNrCls !== this.STRINGS_ERROR &&
      this.caseheightNrCls !== this.STRINGS_ERROR &&
      this.casevolumeNrCls !== this.STRINGS_ERROR &&
      this.caseweightNrCls !== this.STRINGS_ERROR &&
      this.typeunitpriceCdCls !== this.STRINGS_ERROR &&
      this.stockunitpriceNrCls !== this.STRINGS_ERROR &&
      this.arriveunitpriceNrCls !== this.STRINGS_ERROR &&
      this.shipunitpriceNrCls !== this.STRINGS_ERROR &&
      this.depositpriceNrCls !== this.STRINGS_ERROR &&
      this.bsupppointbaraNrCls !== this.STRINGS_ERROR &&
      this.bsupplimitbaraNrCls !== this.STRINGS_ERROR &&
      this.supppointinnercaseNrCls !== this.STRINGS_ERROR &&
      this.supplimitinnercaseNrCls !== this.STRINGS_ERROR &&
      this.supppointcaseNrCls !== this.STRINGS_ERROR &&
      this.supplimitcaseNrCls !== this.STRINGS_ERROR &&
      this.variation1TxCls !== this.STRINGS_ERROR &&
      this.variation2TxCls !== this.STRINGS_ERROR &&
      this.variation3TxCls !== this.STRINGS_ERROR &&
      this.displaypriceNrCls !== this.STRINGS_ERROR
    ) {
      this.isSubmitButtonEnabled =
        this.itemTxCls === this.STRINGS_ACTIVE ||
        this.lotFlCls === this.STRINGS_ACTIVE ||
        this.fragilemarkFlCls === this.STRINGS_ACTIVE ||
        this.upwardmarkFlCls === this.STRINGS_ACTIVE ||
        this.itemlabeluseFlCls === this.STRINGS_ACTIVE ||
        this.typecoldCdCls === this.STRINGS_ACTIVE ||
        this.typeitemCdCls === this.STRINGS_ACTIVE ||
        this.sameitemapplyFlCls === this.STRINGS_ACTIVE ||
        this.uselimitFlCls === this.STRINGS_ACTIVE ||
        this.arriveuselimitNrCls === this.STRINGS_ACTIVE ||
        this.shipuselimitNrCls === this.STRINGS_ACTIVE ||
        this.unitIdCls === this.STRINGS_ACTIVE ||
        this.unitTxCls === this.STRINGS_ACTIVE ||
        this.itemabcIdCls === this.STRINGS_ACTIVE ||
        this.caseCdCls === this.STRINGS_ACTIVE ||
        this.baraamountNrCls === this.STRINGS_ACTIVE ||
        this.pycaseCdCls === this.STRINGS_ACTIVE ||
        this.pycaseamountNrCls === this.STRINGS_ACTIVE ||
        this.bybaracaseCdCls === this.STRINGS_ACTIVE ||
        this.bybaracaseamountNrCls === this.STRINGS_ACTIVE ||
        this.bycaseCdCls === this.STRINGS_ACTIVE ||
        this.bycaseamountNrCls === this.STRINGS_ACTIVE ||
        // this.maxpbinstockNrCls === this.STRINGS_ACTIVE ||
        this.inneramountNrCls === this.STRINGS_ACTIVE ||
        this.innerNrCls === this.STRINGS_ACTIVE ||
        this.caseamountNrCls === this.STRINGS_ACTIVE ||
        this.casespreadNrCls === this.STRINGS_ACTIVE ||
        this.casestackNrCls === this.STRINGS_ACTIVE ||
        this.pcsbarcodeTxCls === this.STRINGS_ACTIVE ||
        this.casebarcodeTxCls === this.STRINGS_ACTIVE ||
        this.lengthNrCls === this.STRINGS_ACTIVE ||
        this.widthNrCls === this.STRINGS_ACTIVE ||
        this.heightNrCls === this.STRINGS_ACTIVE ||
        this.volumeNrCls === this.STRINGS_ACTIVE ||
        this.weightNrCls === this.STRINGS_ACTIVE ||
        this.innerlengthNrCls === this.STRINGS_ACTIVE ||
        this.innerwidthNrCls === this.STRINGS_ACTIVE ||
        this.innerheightNrCls === this.STRINGS_ACTIVE ||
        this.caselengthNrCls === this.STRINGS_ACTIVE ||
        this.casewidthNrCls === this.STRINGS_ACTIVE ||
        this.caseheightNrCls === this.STRINGS_ACTIVE ||
        this.casevolumeNrCls === this.STRINGS_ACTIVE ||
        this.caseweightNrCls === this.STRINGS_ACTIVE ||
        this.typeunitpriceCdCls === this.STRINGS_ACTIVE ||
        this.stockunitpriceNrCls === this.STRINGS_ACTIVE ||
        this.arriveunitpriceNrCls === this.STRINGS_ACTIVE ||
        this.shipunitpriceNrCls === this.STRINGS_ACTIVE ||
        this.depositpriceNrCls === this.STRINGS_ACTIVE ||
        this.bsupppointbaraNrCls === this.STRINGS_ACTIVE ||
        this.bsupplimitbaraNrCls === this.STRINGS_ACTIVE ||
        this.supppointinnercaseNrCls === this.STRINGS_ACTIVE ||
        this.supplimitinnercaseNrCls === this.STRINGS_ACTIVE ||
        this.supppointcaseNrCls === this.STRINGS_ACTIVE ||
        this.supplimitcaseNrCls === this.STRINGS_ACTIVE ||
        this.variation1TxCls === this.STRINGS_ACTIVE ||
        this.variation2TxCls === this.STRINGS_ACTIVE ||
        this.variation3TxCls === this.STRINGS_ACTIVE ||
        this.displaypriceNrCls === this.STRINGS_ACTIVE ||
        this.arrivlabeluseFlCls === this.STRINGS_ACTIVE ||
        this.shiplabeluseFlCls === this.STRINGS_ACTIVE;
    } else {
      this.isSubmitButtonEnabled = false;
    }
  }

  ngAfterViewInit() {
    this.scrollContent.nativeElement.addEventListener('scroll', event => {
      let scrollTop = event.target.scrollTop;
      if (this.anchors[1] > scrollTop) {
        this.tabIndex = 0;
      } else if (this.anchors[1] <= scrollTop && this.anchors[2] > scrollTop) {
        this.tabIndex = 1;
      } else {
        this.tabIndex = 2;
      }
    });
  }

  clrErr() {
    this.errorInfo = '';
  }

  onDeleteButtonClick() {
    this.errorInfo = '';
    this.deleteButtonClick.emit();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9102/wa9102.component.ts